"use strict";
window.$=window.jQuery;

import './partials/menu';
import './sections/jornadas';
import './sections/publicacoes';
import './sections/produtos';
import './sections/destaques';
import './sections/timeline';
import './sections/atividades';
import './sections/auditoria';
import './sections/associados';
import './sections/infografico';
import './sections/edicoes';
import './sections/associe';
import './sections/encontros';
import './casoteca/edicoes';
import './casoteca/galeria';
import './casoteca/mapa';
import './encontro/edicoes';
